import { render, staticRenderFns } from "./Finalize.vue?vue&type=template&id=99752faa&scoped=true&"
import script from "./Finalize.vue?vue&type=script&lang=js&"
export * from "./Finalize.vue?vue&type=script&lang=js&"
import style0 from "./Finalize.vue?vue&type=style&index=0&id=99752faa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99752faa",
  null
  
)

export default component.exports